(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  const button_next = document.querySelector('.slider-button--next');
  const button_prev = document.querySelector('.slider-button--prev');
  const time = document.querySelector('.announcement-bar-slider .grid.slider');
  let slideTimer;

  if (time.dataset.speed > 0) {
    function startSlideTimer() {
      // Clear any existing timer
      if (slideTimer) {
        clearInterval(slideTimer);
      }

      // Start new timer
      slideTimer = setInterval(() => {
        button_next.click();
      }, time.dataset.speed * 1000);
    }

    // Start the timer when the page loads
    startSlideTimer();

    // Restart timer when next or previous button is clicked
    button_next.addEventListener('click', () => {
      startSlideTimer();
    });
    button_prev.addEventListener('click', () => {
      startSlideTimer();
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-promo"] && !window.DesignMode) return;
  try {
    
  // the cookie doesnt exist when they initially land on the page - need to show the widget manually
  const widget = document.querySelector('.widget');
  if (document.cookie.indexOf('showPromo=') == -1) widget.classList.toggle('hide');
  // when they land on the page, set the cookie to always show the promo now
  setCookie('showPromo', true, 30);

  const buttons = document.querySelectorAll('button.quick-add__submit');
  buttons.forEach((button) => {
    button.addEventListener('pointerdown', () => {
      setTimeout(() => {
        // need this for the add to cart to complete
        fetch(location.href)
          .then((response) => response.text())
          .then((html) => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const newContent = doc.querySelector('#promo-widget');
            const currentDiv = document.querySelector('#promo-widget');

            if (newContent && currentDiv) {
              currentDiv.innerHTML = newContent.innerHTML;
            }
            // set event listeners in modal
            handlePromoClicks();
          })
          .catch((error) => console.error('Error loading content:', error));
      }, 750);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dynamic-announcement"] && !window.DesignMode) return;
  try {
    
  let X = document.querySelector('.announcement');
  if (X.getElementsByClassName('icon')[0]) {
    X.getElementsByClassName('icon')[0].addEventListener('pointerdown', () => {
      X.classList.add('hideMenu');
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  const buttons = document.querySelectorAll('button.addtocart');
  buttons.forEach((button) => {
    button.addEventListener('pointerdown', () => {
      setTimeout(() => {
        // need this for the add to cart to complete
        fetch(location.href)
          .then((response) => response.text())
          .then((html) => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const newContent = doc.querySelector('#promo-widget');
            const currentDiv = document.querySelector('#promo-widget');

            if (newContent && currentDiv) {
              currentDiv.innerHTML = newContent.innerHTML;
            }
            // set event listeners in modal
            handlePromoClicks();
          })
          .catch((error) => console.error('Error loading content:', error));
      }, 750);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["megamenu-old"] && !window.DesignMode) return;
  try {
    
  const navItem = document.getElementsByClassName('navItem');
  getPage();

  function getPage() {
    if (p === 'blog' || p === 'article') {
      for (let i = 0; i < navItem.length; i++) {
        // console.log('blog');
        if (navItem[i].innerText === 'Blog') {
          navItem[i].classList.add('activeNavItem');
        }
      }
    }
    if (p === 'collection' || p === 'product') {
      for (let i = 0; i < navItem.length; i++) {
        if (navItem[i].innerText === 'Shop') {
          navItem[i].classList.add('activeNavItem');
        }
      }
    }
    // will need to be changed upon going live probably
    if (p === 'page.contact') {
      for (let i = 0; i < navItem.length; i++) {
        if (navItem[i].innerText === 'Contact') {
          navItem[i].classList.add('activeNavItem');
        }
      }
    }
    if (p === 'page.retail') {
      for (let i = 0; i < navItem.length; i++) {
        if (navItem[i].innerText === 'Retail') {
          navItem[i].classList.add('activeNavItem');
        }
      }
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["megamenu"] && !window.DesignMode) return;
  try {
    
  const navItem = document.getElementsByClassName('mm-first__nav-item');
  getPage();

  function getPage() {
    if (p === 'blog' || p === 'article') {
      for (let i = 0; i < navItem.length; i++) {
        // console.log('blog');
        if (navItem[i].innerText === 'Blog') {
          navItem[i].classList.add('activeNavItem');
        }
      }
    }
    if (p === 'collection' || p === 'product') {
      for (let i = 0; i < navItem.length; i++) {
        if (navItem[i].innerText === 'Shop') {
          navItem[i].classList.add('activeNavItem');
        }
      }
    }
    // will need to be changed upon going live probably
    if (p === 'page.contact') {
      for (let i = 0; i < navItem.length; i++) {
        if (navItem[i].innerText === 'Contact') {
          navItem[i].classList.add('activeNavItem');
        }
      }
    }
    if (p === 'page.retail') {
      for (let i = 0; i < navItem.length; i++) {
        if (navItem[i].innerText === 'Retail') {
          navItem[i].classList.add('activeNavItem');
        }
      }
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multi-promos"] && !window.DesignMode) return;
  try {
    
  function getValue(x) {
    let value = x.options[x.selectedIndex].value;
    let text = x.options[x.selectedIndex].text;
    let price = x.options[x.selectedIndex].getAttribute('pr');

    let hiddenInput = document.getElementsByClassName('hiddenSubmit');
    hiddenInput[0] ? hiddenInput[0].setAttribute('value', value) : null;

    let submitInput = document.getElementsByClassName('tile-submit-btn');
    submitInput[0] ? submitInput[0].setAttribute('prodid', value) : null;

    let bundlePrice = document.getElementsByClassName('bundlePrice');
    bundlePrice[0] ? (bundlePrice[0].innerHTML = price) : null;
  }

  const btnContainers = document.getElementsByClassName('bundleBtnContainer');
  let numShownTiles;
  let tiles = document.querySelectorAll('.bundleTile');

  Array.from(btnContainers).forEach((item, i) => {
    item.addEventListener('click', (event) => bundleBtns(event));
  });

  // on page load, check the screen width and display the appropriate # of tiles
  if (window.matchMedia('(max-width: 630px)').matches) {
    numShownTiles = 1;
  } else if (window.matchMedia('(max-width: 910px)').matches) {
    numShownTiles = 2;
  } else if (window.matchMedia('(max-width: 1380px)').matches) {
    numShownTiles = 3;
  } else {
    numShownTiles = 4;
  }

  // dynamically get number of initially shown tiles
  let show = Array.from(tiles).filter((tile) => tile.classList.contains('shownTile'));
  show = show.length;
  // Hide extra tiles if it's a smaller screen size (numShownTiles is set from media queries)
  for (let i = 0; i < show - numShownTiles; i++) {
    if (tiles[show - 1 - i].classList.contains('shownTile')) tiles[show - 1 - i].classList.remove('shownTile');
    if (!tiles[show - 1 - i].classList.contains('hiddenTile')) tiles[show - 1 - i].classList.add('hiddenTile');
  }

  let actives = [];
  tiles.forEach((tile) => {
    const num = tile.getAttribute('data-bundle-index');
    if (tile.classList.contains('shownTile')) actives.push(num);
  });

  function bundleBtns(event) {
    let newActives = [];

    // if we clicked the previous button, flip the number
    if (event.target.closest('.bundleBtnContainer').classList.contains('prevBundle')) {
      numShownTiles = -Math.abs(numShownTiles);
    } else {
      numShownTiles = Math.abs(numShownTiles);
    }

    tiles.forEach((tile) => {
      if (tile.classList.contains('shownTile')) tile.classList.remove('shownTile');
      if (!tile.classList.contains('hiddenTile')) tile.classList.add('hiddenTile');
    });

    actives.forEach((active, i) => {
      active = parseInt(active);
      let index = active + numShownTiles;
      // we're at the end of the array, loop to the front
      if (index > tiles.length) index = index - tiles.length;
      // we're at the beginning, loop to the back
      if (index <= 0) index = active + tiles.length + numShownTiles;
      newActives.push(index);
    });
    actives = newActives;

    newActives.forEach((number, i) => {
      tiles.forEach((tile, i) => {
        let num = tile.getAttribute('data-bundle-index');
        if (parseInt(num) == number) {
          tile.classList.contains('hiddenTile') ? tile.classList.remove('hiddenTile') : null;
          !tile.classList.contains('shownTile') ? tile.classList.add('shownTile') : null;
        }
      });
    });
  }

  } catch(e) { console.error(e); }
})();
})();
